<template>
  <div :class="$style['connect-accounts-container']">
    <ConnectAccountsLayout
      :show-error="showError && !errorMessage"
      :show-product-message="false"
      :event-tracking-fields="commonTrackingFields"
    >
      <template #titles>
        <h2 :class="$style.heading">
          {{ $t('paymentsPage.verifyRevenue') }}
        </h2>
        <p :class="$style['sub-heading']">
          {{ $t('paymentsPage.connectAtLeastOneSalesPlatform') }}
        </p>
      </template>

      <template v-if="errorMessage && showError" #errorMessage>
        <Message severity="error" :closable="false">
          <p>
            {{ errorMessage }}
            Need help? You can reach us by phone at +1 (415) 610-5166 (9AM - 6PM
            ET) or by email at
            <a href="mailto:support@clear.co">support@clear.co</a>.
          </p>
        </Message>
      </template>

      <ProductMessage />
      <ConnectedAccountSalesTileGroup
        ref="tileGroup"
        v-model:show-error="showError"
        v-model:error-message="errorMessage"
        :event-tracking-fields="commonTrackingFields"
        load-all-platforms
      />
      <template #cta>
        <div :class="$style['buttons-container']">
          <LinkContainerButton
            :text="$t('common.buttons.nextStep')"
            center-cta
            :class="$style['next-btn']"
            @nextClick="nextStep"
          />
        </div>
      </template>
    </ConnectAccountsLayout>
  </div>
</template>

<script>
import { mapGetters, useStore } from 'vuex';
import stateModuleAware from '@/mixins/state-module-aware';
import { mapStateModuleGetters } from '@/utils/state-modules';
import Message from 'primevue/message';
import { RouteNames } from '@/data/routes';
import { useProfiling } from '@/composables/useProfiling';

import ConnectedAccountSalesTileGroup from '@/pages/connected-accounts/components/ConnectedAccountSalesTileGroup.vue';
import LinkContainerButton from '@/components/buttons/LinkContainerButton.vue';
import ConnectAccountsLayout from '@/components/layouts/ConnectAccountsLayout.vue';
import ProductMessage from '@/components/banners/ProductMessage.vue';

export default {
  components: {
    LinkContainerButton,
    ConnectedAccountSalesTileGroup,
    ConnectAccountsLayout,
    ProductMessage,
    Message,
  },
  mixins: [stateModuleAware],
  data() {
    return {
      showError: false,
      errorMessage: '',
    };
  },
  setup() {
    const store = useStore();
    const profiling = useProfiling(RouteNames.CONNECTED_ACCOUNTS.INDEX, {
      type: store.getters.eventTypeBasedOnLoginsCount,
    });

    return { profiling };
  },
  computed: {
    ...mapGetters(['productSegmentLabel', 'connectedSalesAccounts']),
    ...mapStateModuleGetters(['experimentName']),
    hasConnectedSalesAccounts() {
      return this.connectedSalesAccounts.length;
    },
    commonTrackingFields() {
      return {
        productSegment: this.productSegmentLabel,
        experiment: this.experimentName,
        targetArea: this.$route.name,
      };
    },
  },
  methods: {
    nextStep() {
      this.errorMessage = '';
      if (!this.hasConnectedSalesAccounts) {
        this.showError = true;
        return;
      }

      this.profiling.finish();

      this.$router.push({
        name: RouteNames.CONNECTED_ACCOUNTS.MARKETING,
      });
    },
  },
};
</script>

<style lang="less" module>
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.next-btn {
  button {
    background-color: @color-purple-2022;
    &:hover {
      background-color: @color-purple-2022 !important;
    }
  }
}

h2.heading {
  font-size: 21px;
  line-height: 30px;
  font-weight: 500;
  margin: 0 0 24px;
}

.sub-heading {
  max-width: 550px;
  margin: 0 auto 0;
}

@media screen and (max-width: 500px) {
  h2.heading,
  .sub-heading {
    text-align: left;
  }
}
</style>
